import { render, staticRenderFns } from "./GateSettingForm.vue?vue&type=template&id=91bf8676&scoped=true&"
import script from "./GateSettingForm.vue?vue&type=script&lang=js&"
export * from "./GateSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bf8676",
  null
  
)

export default component.exports